/** MAX Bot API limits — https://dev.max.ru/docs-api/methods/POST/uploads */
export const MAX_MESSENGER_VIDEO_SIZE_MB = 250;
export const MAX_MESSENGER_IMAGE_SIZE_MB = 50;

export function isMaxMessengerEnabled(messengerIds) {
  return Array.isArray(messengerIds) && messengerIds.includes("max");
}

export function getMaxVideoLimitHintText() {
  return `В MAX видео для сотрудников должно быть не больше ${MAX_MESSENGER_VIDEO_SIZE_MB} МБ — это ограничение мессенджера.`;
}

export function getMaxMediaLimitsHintForMessengers(messengerIds) {
  if (!isMaxMessengerEnabled(messengerIds)) {
    return null;
  }
  return getMaxVideoLimitHintText();
}
